import { MYHOUSE_REGISTER_CALLBACK_URL_KEY, MYHOUSE_REGISTER_CALLBACK_URL_PARAM } from "@Root/contants/myhouseRegister";
import { useSessionStorage } from "@Root/utils/storageUtils";
import { isString } from "lodash";
import { useEffect } from "react";
import queryString from 'query-string';

const NAVER_DOMAIN_REGEX = /^https:\/\/(.*\.)?naver\.com\/.+/;

/**
 * 아파트 등록/인증 후 돌아갈 callback URL 을 SessionStorage 에 저장하여 
 * 세션이 종료되기 전까지는 'handleClose' 시점에 getStorage 를 통해 URL 을 얻어온다.
 * 
 */
const useSetAuthCallbackUrl = () : void  => {
    const { setStorage } = useSessionStorage();
    const query = typeof window !== undefined ? queryString.parse(window.location.search) : null;
    const authCallbackUrl = query?.[MYHOUSE_REGISTER_CALLBACK_URL_PARAM];
  
    useEffect(() => {
        if (isString(authCallbackUrl) &&  NAVER_DOMAIN_REGEX.test(authCallbackUrl)) {
            setStorage(MYHOUSE_REGISTER_CALLBACK_URL_KEY, authCallbackUrl);
        }
    }, [authCallbackUrl]);
}

export default useSetAuthCallbackUrl;